import { render, staticRenderFns } from "./dlgEditEmail.vue?vue&type=template&id=a38987fe"
import script from "./dlgEditEmail.vue?vue&type=script&lang=js"
export * from "./dlgEditEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports